// Public surface for the account module.
//
// Account is a NAMESPACE parent — unlike wallet (which has a shared tab page),
// account has no chrome of its own. It just groups two sibling sub-modules
// that share a "user account" domain:
//   - profile/         — user profile, settings, KYC details, document preview
//   - bankAccounts/    — bank account list / add / detail / withdrawal source
// External consumers go through @modules/account — never @modules/account/<sub>.

import { profileRoutes } from './profile'
import { bankAccountsRoutes } from './bankAccounts'

export const accountRoutes = [...profileRoutes, ...bankAccountsRoutes]

// profile surface — read by app shell + multiple feature modules.
export {
  ACCOUNT_KYC_STATUS,
  KYC_SUBMISSION_STATUS,
  ACCOUNT_STATE,
  PAUSED_REASON,
  INVESTOR_STATUS,
  ONBOARDING_STATUS,
  shouldDisableFinancialActions,
  isKycVerificationPending,
  resolveKycActionState,
  useAccountAccessRestriction,
  useKycActionState,
  AccountRestrictionNotice,
  KycActionBlocker,
  KycReviewNotice,
  useUserProfileQuery,
  useAccountStatusQuery,
  useKycDetailsQuery,
  useKycStatusQuery,
  useUpdateProfileMutation,
  useReInitiateKycMutation,
} from './profile'
export type {
  AccountKycStatusValue,
  KycSubmissionStatusValue,
  AccountStateValue,
  PausedReasonValue,
  InvestorStatusKey,
  InvestorStatusValue,
  OnboardingStatusKey,
  OnboardingStatusValue,
  UserProfile,
  AccountStatus,
  AccountStatusBankAccount,
  AccountAccessRestriction,
  KycActionState,
  KycActionStateGate,
  KycDetails,
  KycDocument,
  KycStatus,
  UpdateProfileInput,
} from './profile'

// bankAccounts surface — wallet's fiat sub-module reads the verified bank list;
// StatementUploadInput is reused by wallet's deposit-confirm receipt upload.
export { useBankAccountsQuery, StatementUploadInput } from './bankAccounts'
export type { BankAccount, BankAccountDetail, CreatedBankAccount } from './bankAccounts'
